import { Row, Col, Panel, Table, Whisper, IconButton, Popover, Dropdown } from "rsuite"
import MoreIcon from '@rsuite/icons/legacy/More';

const { Cell } = Table;
const STATUS_VERBOSE = {
    "draft": "Черновик",
    "waiting": "В ожидании",
    "in_progress": "В процессе",
    "done": "Завершен",
    "cancelled": "Отменен",
    "rejected": "Отклонен"
}

export default function StatusCell ({ rowData, dataKey, ...props }) {
    return (
        <Cell {...props} style={{flexWrap: "nowrap"}}>
            {STATUS_VERBOSE[rowData[dataKey]]}
        </Cell>
    );
};